<template>
    <div>
        
        <v-card class="rounded-lg px-5 py-2" 
                hover
                @click="onClick">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title
                  class="text-h5"
                  v-text="pipeline.name"
                ></v-card-title>

                <v-card-subtitle v-html="pipeline.description"></v-card-subtitle>

                <v-card-actions>
                  <v-btn class=""
                         color="primary"
                         large
                         rounded
                         depressed
                         @click="onClick">
                    APRI
                  </v-btn>
                </v-card-actions>
              </div>

              <v-avatar
                class="ma-3"
                size="125"
                tile
              >
                <v-img :src="pipeline.illustration"></v-img>
              </v-avatar>
            </div>
        </v-card>

    </div>
</template>

<script>
export default 
{
   name: 'PipelineCard',

   mixins: [],

   components: 
   {

   },

   data: () => ({

   }),

   props: {
    pipeline:
    {
        type: Object,
        required: true
    }
   },

   computed: {},

   methods:
   {
    onClick()
    {
        this.$emit('click', this.pipeline)
    }
   },

   mounted()
   {

   }
}
</script>